/// <reference path='../_all.ts' />

module editor {
  'use strict';

  export class EditorFilter {
    constructor(

      public rpv?: IRouteParameter[],
      public UseRouteParam?: boolean, 
      public Replace?: boolean, 

      //ContentFilter:
      public Category? : number, 
      public Filter1?: number, 
      public Filter2?: number, 
      public Filter3?: number, 
      public FilterString1? : string, 
      public FilterString2? : string, 
      public FilterString3?: string,
      public IsLanguageIndifferent? : boolean,
      public Description?: string,
      public ContentId? : number,
      public ContentFormat?: number
      ) { }
  }
}